function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 4,
    centeredSlides: true,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1.5,
        spaceBetween: 15,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}
// Call the function
initializeReviewsSwiper();

function initMCSSlider() {
  const sliderEl = document.querySelector('.M-mcs-Swiper');

  if (!sliderEl) return;

  // Prevent duplicate initialization
  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  sliderEl.classList.remove('preview');

  const swiper = new Swiper('.M-mcs-Swiper', {
    speed: 300,
    loop: true,
    centeredSlides: true,

    navigation: {
      nextEl: '.m-mcs-next',
      prevEl: '.m-mcs-prev',
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },

      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      950: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

  // Example slide change event
  swiper.on('slideChange', function () {
    console.log('Active slide:', swiper.realIndex);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initMCSSlider);

// Shopify Theme Editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMCSSlider);
  document.addEventListener('shopify:section:unload', function () {
    const sliderEl = document.querySelector('.M-mcs-Swiper');

    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }
  });
}

function initUISSlider() {
  var swiper = new Swiper(".UISSlider", {
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slidesPerView: 1.7,
    spaceBetween: 10,

    breakpoints: {
      0: {
        slidesPerView: 1.7,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 2.8,
        spaceBetween: 10,
      },
    },
  });
}

document.addEventListener('click', function(e) {
  const button = e.target.closest('.u-collapsible-toggle');
  if (!button) return;
  const item = button.closest('.u-collapsible-item');
  const content = item.querySelector('.u-collapsible-content');
  const isAlreadyActive = item.classList.contains('active');
  const allActiveItems = document.querySelectorAll('.u-collapsible-item.active');
  allActiveItems.forEach(activeItem => {
    activeItem.classList.remove('active');
    const activeContent = activeItem.querySelector('.u-collapsible-content');
    if (activeContent) {
      activeContent.style.maxHeight = null;
    }
  });
  if (!isAlreadyActive) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
});
document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".uannocmentslider", {
    loop: true, 
    autoplay: {
        delay: 3000,
        disableOnInteraction: false, 
    },
    speed: 1000,
    });
});
document.addEventListener('click', (e) => {
  const button = e.target.closest('[ref="addToCartButton"]');
  if (!button) return;

  const scope = button.closest('.shopify-section') || document;

  const addonCard = scope.querySelector('[data-u-addon-card]');
  const addonCheckbox = scope.querySelector('[data-u-addon-checkbox]');

  if (!addonCard || !addonCheckbox || !addonCheckbox.checked) return;

  const addonVariantId = addonCard.dataset.addonVariantId;
  if (!addonVariantId) {
    console.warn('Addon variant id missing — check addon_product setting.');
    return;
  }

  setTimeout(async () => {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: addonVariantId, quantity: 1 }] })
      });
      const sectionsRes = await fetch(`${window.location.pathname}?sections=cart-drawer-section`);
      const sectionsData = await sectionsRes.json();
      const newHtml = sectionsData['cart-drawer-section'];
      if (newHtml) {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(newHtml, 'text/html');

        const newInner = newDoc.querySelector('[data-hydration-key="cart-drawer-inner"]');
        const oldInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');

        if (newInner && oldInner) {
          oldInner.replaceWith(newInner);
        }
      }

      const cart = await fetch('/cart.js').then(r => r.json());
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { cart }
      }));

    } catch (err) {
      console.error('Addon add-to-cart failed:', err);
    }
  }, 700);
}, true);

document.addEventListener('click', (e) => {
  if (e.target.matches && e.target.matches('[data-u-addon-checkbox]')) {
    e.stopPropagation();
  }
});